import OliverText from "@builder/components/general/OliverText";
import SimpleCheckbox from "@builder/components/general/SimpleCheckbox";
import { ActionEditorItem, updateStepperActions } from "@builder/store/slices/actionBuilderSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { ActionType } from "@common/build/types";
import { useEffect } from "react";

const ResumeParkOrder = () => {
    const { id } = useAppSelector(state => state.actionBuilder.current);
    const actionStep = useAppSelector(state => state.actionBuilder.actionsEditor.find(item => item.id === id));
    const dispatch = useAppDispatch();

    useEffect(() => {
        const action = {
            type: ActionType.RESUME_PARK_ORDER
        };
        const updatedStep = { ...actionStep };
        updatedStep.action = { ...action };

        if (JSON.stringify(updatedStep) !== JSON.stringify(actionStep)) {
            dispatch(updateStepperActions({ id: id as string, item: updatedStep as ActionEditorItem }));
        }
    }, [actionStep, dispatch, id]);

    return (
        <div className="function-add-cart-note-wrapper">
            <OliverText text="How do you want to resume ?" size="xs" weight="medium-heavy" translatePrefix="popup.actionBuilder." />
            <div className="function-add-cart-note">
                <div className="function-checkbox-wrapper">
                    <div className="function-checkbox-label-wrapper">
                        <OliverText text="Resume" size="xs" weight="medium-heavy" translatePrefix="popup.actionBuilder." />
                        <OliverText
                            text="Open a held order for edits or payment."
                            size="xs"
                            weight="light"
                            translatePrefix="popup.actionBuilder."
                        />
                    </div>
                    <SimpleCheckbox callback={() => {}} checked={true} label="" value="" custom={false} />
                </div>
            </div>
        </div>
    );
};

export default ResumeParkOrder;
